// Vendor Libs
import React, {useEffect} from 'react';
import PropTypes from 'prop-types';

// Dish Tech React
import {useForm, useToast} from '@dishtech-react/hooks';
import {InputTextField} from '@dishtech-react/core';

// Material UI
import CancelIcon from '@material-ui/icons/Cancel';
import SaveIcon from '@material-ui/icons/Save';
import {Button, Grid} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

// Components

// Configs
import {serviceConfig} from '../../../config/service-config';

// Hooks
import {useStorefront} from '../../hooks/use-storefront';

const useStyles = makeStyles(theme => ({
  border: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  button: {
    margin: theme.spacing(2, 2, 1, 0),
  },
  container: {
    alignItems: 'center',
    display: 'flex',
    margin: '0 auto',
    minWidth: '1000px',
    justifyContent: 'center',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  grid: {
    flexWrap: 'nowrap',
  },
  gridItemLeft: {
    width: '600px',
  },
}));

const FORM_KEY = 'STOREFRONT';

const StorefrontForm = ({onCancel, onSave}) => {
  const classes = useStyles();
  const {mode} = useStorefront();
  const {
    formValid,
    formValues,
    formValues: {description, name},
    registerForm,
    resetForm,
    setFieldValue,
    submitForm,
  } = useForm(serviceConfig, FORM_KEY, mode);
  const {createToast} = useToast();

  useEffect(() => {
    registerForm();

    if (mode === 'create') {
      setFieldValue('active', false);
    }

    return () => resetForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSave = () => {
    submitForm(formValues).then(({error}) => {
      if (error) {
        createToast(error, {
          variant: 'error',
          persist: true,
          onClose: () => onSave(),
        });
      } else {
        createToast(`Successfully ${mode}d Storefront.`);
        onSave();
      }
    });
  };

  return (
    <>
      <Grid className={classes.grid} container={true} spacing={4}>
        <Grid className={classes.gridItemLeft} item={true}>
          {mode !== 'view' ? (
            <InputTextField
              autoFocus={true}
              className={classes.border}
              disabled={mode !== 'create'}
              fullWidth={true}
              id="name"
              label="Name"
              margin="dense"
              required={mode === 'create'}
              type="text"
              value={name || ''}
              onChange={event => setFieldValue('name', event.target.value)}
            />
          ) : null}
          {mode !== 'view' ? (
            <InputTextField
              autoFocus={true}
              className={classes.border}
              fullWidth={true}
              id="description"
              label="Description"
              margin="dense"
              type="text"
              value={description || ''}
              onChange={event => setFieldValue('description', event.target.value)}
            />
          ) : null}
          {mode !== 'view' ? (
            <Select
              className={classes.container}
              fullWidth={true}
              id="storefrontShelves"
              label="Storefront Shelves"
              value="testShelf"
            >
              <MenuItem value="testShelf">Storefront Shelves</MenuItem>
            </Select>
          ) : null}
          {mode !== 'view' ? (
            <Select
              className={classes.container}
              fullWidth={true}
              id="availableShelves"
              label="Available Shelves"
              value="testShelf"
            >
              <MenuItem value="testShelf">Available Storefronts</MenuItem>
            </Select>
          ) : null}
          <Button
            className={classes.button}
            color="default"
            startIcon={<CancelIcon />}
            variant="contained"
            onClick={onCancel}
          >
            Cancel
          </Button>

          {mode !== 'view' ? (
            <Button
              className={classes.button}
              color="primary"
              disabled={!formValid}
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={handleSave}
            >
              {mode}
            </Button>
          ) : null}
        </Grid>
      </Grid>
    </>
  );
};

StorefrontForm.propTypes = {
  onCancel: PropTypes.func,
  onSave: PropTypes.func,
};

export default StorefrontForm;
